import React from "react";
import { Box, Heading, Text, Flex, Image } from "@chakra-ui/react";

const About = () => {
  return (
    <Flex direction="column" align="center" mt={8} px={4} id="about">
      <Box
        w="100%"
        maxW="800px"
        bg="white"
        p={6}
        borderRadius="md"
        boxShadow="md"
      >
        <Heading as="h1" size="xl" mb={4} textAlign="center">
          About Us
        </Heading>
        <Flex justify="center" mb={4}>
          <Image
            src="../2.jpg"
            alt="Ashraya PG"
            borderRadius="md"
            width="300px" // Adjust width to reduce size
            height="auto"
          />
        </Flex>
        <Text fontSize="md" lineHeight="tall" color="#333">
          Welcome to Ashraya, your ideal home away from home. Nestled in a
          serene neighborhood, Ashraya offers a comfortable and welcoming
          environment for students, working professionals, and travelers alike.
          Our facility is equipped with modern amenities, including spacious,
          fully-furnished rooms, high-speed Wi-Fi, a well-maintained common
          kitchen, and 24/7 security to ensure your stay is both convenient and
          safe. Experience the perfect blend of comfort and community at
          Ashraya, where every guest is treated with warmth and care. Join us
          for a peaceful and enriching living experience.
        </Text>
        <Text fontSize="md" lineHeight="tall" color="#333" mt={4}>
          Our PG is located in a prime area, close to major educational
          institutions, shopping centers, and public transport. We offer fully
          furnished rooms with modern amenities, including Wi-Fi, laundry
          services, and 24/7 security. Our goal is to create a supportive
          community where girls can focus on their studies and personal growth
          without any worries.
        </Text>
        <Text fontSize="md" lineHeight="tall" color="#333" mt={4}>
          At Ashraya Girl's PG, we believe in maintaining high standards of
          hygiene and cleanliness. Our staff is friendly and always ready to
          assist you with any needs or concerns you may have. We also organize
          various activities and events to foster a sense of camaraderie and
          belonging among our residents.
        </Text>
        <Text fontSize="md" lineHeight="tall" color="#333" mt={4}>
          Thank you for considering Ashraya Girl's PG as your home away from
          home. We look forward to welcoming you and ensuring you have a
          comfortable and enjoyable stay.
        </Text>
      </Box>
    </Flex>
  );
};

export default About;
